module.exports = __webpack_public_path__ + "img/logo.f096c012.svg";